module.exports = __webpack_public_path__ + "web/img/sign-60.478254ea.png";